var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.385,
    height: 21.001,
    viewBox: "0 0 19.385 21.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7186",
    "data-name": "Path 7186",
    d: "M13.808,13a.807.807,0,0,0-.808.808v6.462a.808.808,0,1,0,1.615,0V13.808A.807.807,0,0,0,13.808,13Z",
    transform: "translate(-1.731 -1.923)",
    fill: "#e31017"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7187",
    "data-name": "Path 7187",
    d: "M17.808,13a.807.807,0,0,0-.808.808v6.462a.808.808,0,1,0,1.615,0V13.808A.807.807,0,0,0,17.808,13Z",
    transform: "translate(-2.5 -1.923)",
    fill: "#e31017"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7188",
    "data-name": "Path 7188",
    d: "M16.116,3H11.269A1.617,1.617,0,0,0,9.654,4.615V6.231H4.808a.808.808,0,1,0,0,1.615H6.423V21.577A2.426,2.426,0,0,0,8.846,24h9.693a2.426,2.426,0,0,0,2.423-2.423V7.846h1.615a.808.808,0,0,0,0-1.615H17.731V4.615A1.617,1.617,0,0,0,16.116,3Zm3.231,18.577a.808.808,0,0,1-.808.808H8.846a.808.808,0,0,1-.808-.808V7.846H19.347ZM11.269,6.231V4.615h4.846V6.231Z",
    transform: "translate(0 0)",
    fill: "#e31017"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.329832e7d52aa9fdca7fa90f66fc4d72.svg";
export { ForwardRef as ReactComponent };